module.exports = __webpack_public_path__ + "static/media/comments-alt.6fb72959.svg";